import type { GetNextPageParamFunction } from "@tanstack/react-query";

import type { IApiResponse, IPagination } from "@/api";

const getNextPageParam: GetNextPageParamFunction<
  number,
  IApiResponse<IPagination<unknown>>
> = (lastPage) => {
  const currentPage = lastPage?.data?.current_page || 1;
  const totalPages = lastPage?.data?.total_pages || 0;

  return currentPage < totalPages ? currentPage + 1 : undefined;
};

export const infiniteHelper = {
  getNextPageParam,
  initialPageParam: 1,
};
